import React from "react";
import SbEditable from "storyblok-react";
import { InlineWidget } from "react-calendly";

const Calendly = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className={`relative bg-white py-4 px-6`}>
        <div className="relative mx-auto max-w-7xl">
          <div className="h-[1200px] xl:h-[800px]">
            <InlineWidget
              styles={{ height: "1200px" }}
              url="https://calendly.com/tlf-research?hide_gdpr_banner=1"
            />
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default Calendly;